// https://minntgmbh.atlassian.net/wiki/spaces/BROT/pages/3751215124/BSB+Enums

export enum SecBEPermissionPartnerAppEnum {
    PAU = 'PAU',
    PAU_CONTRACTS_CSP_READONLY = 'PAU_CONTRACTS_CSP_READONLY',
    PAU_CONTRACTS_CSP_EDIT = 'PAU_CONTRACTS_CSP_EDIT',
    PAU_CONTRACTS_CSP_CONNECTED = 'PAU_CONTRACTS_CSP_CONNECTED',
    PAU_PROJECTS = 'PAU_PROJECTS',
    PAU_SERVICE = 'PAU_SERVICE',
}
